module.exports = __webpack_public_path__ + "static/hc037-863daf9cbe10f00a93b67b856cf48b92.jpg";